exports.fluids = [
  {
    key: 'ALBUMIN_5',
    label: {
      en: 'Albumin 5 %'
    },
    abbreviation: {
      en: 'Alb 5%'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500'],
    defaultFluidColor: 'LIGHT_YELLOW'
  },
  {
    key: 'ALBUMIN_25',
    label: {
      en: 'Albumin 25%'
    },
    abbreviation: {
      en: 'Alb 25%'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500'],
    defaultFluidColor: 'LIGHT_YELLOW'
  },
  {
    key: 'FRESH_FROZEN_PLASMA',
    label: {
      en: 'Fresh Frozen Plasma'
    },
    abbreviation: {
      en: 'FFP'
    },
    availableBagVolumes: ['ML_300'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_300'],
    defaultFluidColor: 'YELLOW'
  },
  {
    key: 'LR',
    label: {
      en: 'Lactated Ringers (LR)'
    },
    abbreviation: {
      en: 'LR'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D5LR',
    label: {
      en: '5% Dextrose in Lactated Ringers (D5LR)'
    },
    abbreviation: {
      en: 'D5LR'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_5_NACL_0_225',
    label: {
      en: '5% Dextrose Sodium Chloride 0.225%'
    },
    abbreviation: {
      en: 'D5 1/4NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_5_NACL_0_9',
    label: {
      en: '5% Dextrose Sodium Chloride 0.9%'
    },
    abbreviation: {
      en: 'D5NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_10_NACL_0_2',
    label: {
      en: 'Dextrose 10% and Sodium Chloride 0.2%'
    },
    abbreviation: {
      en: 'D10 1/4NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_10_NACL_0_45',
    label: {
      en: 'Dextrose 10% and Sodium Chloride 0.45 %'
    },
    abbreviation: {
      en: 'D10 1/2NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_2_5_NACL_0_45',
    label: {
      en: 'Dextrose 2.5% and Sodium Chloride 0.45 %'
    },
    abbreviation: {
      en: 'D2.5 1/2NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D5W_5',
    label: {
      en: 'D5W Dextrose 5% in Water'
    },
    abbreviation: {
      en: 'D5W'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D5W_10',
    label: {
      en: 'D10W Dextrose 10% in Water'
    },
    abbreviation: {
      en: 'D10W'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'D_5_NACL_0_45',
    label: {
      en: '5% Dextrose in 0.45% Sodium Chloride'
    },
    abbreviation: {
      en: 'D5 1/2NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'INJECTABLE_NACL_3',
    label: {
      en: 'Sodium Chloride 3% Injectable Solution (NaCl 3%)'
    },
    abbreviation: {
      en: '3% Saline'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'NACL_0_9',
    label: {
      en: '0.9% Sodium Chloride'
    },
    abbreviation: {
      en: 'NS'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'CRYO',
    label: {
      en: 'Cryoprecipitate (cryo)'
    },
    abbreviation: {
      en: 'Cryo'
    },
    availableBagVolumes: ['ML_10'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_10'],
    defaultFluidColor: 'YELLOW'
  },
  {
    key: 'DEXTRAN_40_10_5',
    label: {
      en: 'Dextran 40-10% solution in 5% Dextrose'
    },
    abbreviation: {
      en: 'Dextran 40-10% in D5'
    },
    availableBagVolumes: ['ML_500'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_250'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'DEXTRAN_40_10_NACL_0_9',
    label: {
      en: 'Dextran 40-10% solution in 0.9 % (Sodium Chloride)'
    },
    abbreviation: {
      en: 'Dextran 40-10% in NS'
    },
    availableBagVolumes: ['ML_500'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_250'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'PACKED_RED_BLOOD_CELLS',
    label: {
      en: 'Packed Red Blood Cells'
    },
    abbreviation: {
      en: 'PRBC'
    },
    availableBagVolumes: ['ML_350'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_350'],
    defaultFluidColor: 'RED'
  },
  {
    key: 'PLASMA_LIQUID',
    label: {
      en: 'Plasma Liquid (never frozen)'
    },
    abbreviation: {
      en: 'Plasma Liquid'
    },
    availableBagVolumes: ['ML_300'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_300'],
    defaultFluidColor: 'YELLOW'
  },
  {
    key: 'PLATELETS',
    label: {
      en: 'Platelets'
    },
    abbreviation: {
      en: 'Platelets'
    },
    availableBagVolumes: ['ML_300'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_300'],
    defaultFluidColor: 'YELLOW'
  },
  {
    key: 'KCL_10_NS_0_9',
    label: {
      en: 'Potassium Chloride 10 mEq in 0.9% NS'
    },
    abbreviation: {
      en: 'NS +10K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'KCL_10_NS_0_45',
    label: {
      en: 'Potassium Chloride 10 mEq in 0.45 NS (half normal)'
    },
    abbreviation: {
      en: '1/2NS +10K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'KCL_20_NS_0_9',
    label: {
      en: 'Potassium Chloride 20 mEq in 0.9% NS'
    },
    abbreviation: {
      en: 'NS + 20K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'K_40_NS_0_9',
    label: {
      en: 'Potassium 40 mEq in 0.9% NS'
    },
    abbreviation: {
      en: 'NS + 40K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'K_20_NS_0_33',
    label: {
      en: 'Potassium 20 mEq, D5, and Sodium Chloride 0.33%'
    },
    abbreviation: {
      en: 'D5 1/3NS + 20K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'K_20_NS_0_45',
    label: {
      en: 'Potassium 20 mEq, D5, and Sodium Chloride 0.45%'
    },
    abbreviation: {
      en: 'D5 1/2NS + 20K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'K_30_NS_0_45',
    label: {
      en: 'Potassium 30 mEq, D5, and Sodium Chloride 0.45%'
    },
    abbreviation: {
      en: 'D5 1/2NS + 30K'
    },
    availableBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    productTypes: [
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_50', 'ML_100', 'ML_250', 'ML_500', 'ML_1000'],
    defaultFluidColor: 'CLEAR'
  },
  {
    key: 'WHOLE_BLOOD',
    label: {
      en: 'Whole Blood'
    },
    abbreviation: {
      en: 'Whole Blood'
    },
    availableBagVolumes: ['ML_500'],
    productTypes: [
      'EMS',
      'MILITARY',
      'NURSING'
    ],
    defaultDosingTypes: ['ML_HR'],
    defaultBagVolumes: ['ML_250'],
    defaultFluidColor: 'RED'
  }
];
